import { getAmplitudeInstance } from '../amplitudeHelpers';
import AskAllTrailsQueryType from '../enums/AskAllTrailsQueryType';
import CardLocation from '../enums/CardLocation';

type logAskAllTrailsQuerySubmittedParams = {
  entry_point?: CardLocation;
  query_id?: string;
  query_length?: number;
  query_submitted?: string;
  query_type?: AskAllTrailsQueryType;
  session_id?: string;
};

/**
 * User submits a query in Ask AllTrails (typed or from a suggested prompt).
 * @param params - Attributes to log with the amplitude event
 * @param params.entry_point - Surface where the user entered Ask AllTrails.
 * @param params.query_id - Unique id of the query submitted by the user.
 * @param params.query_length - Character length of the submitted query.
 * @param params.query_submitted - Query text submitted by the user.
 * @param params.query_type - Whether the query was typed or selected from a suggestion.
 * @param params.session_id - Unique id for a continuous Ask AllTrails session.
 */
const logAskAllTrailsQuerySubmitted = (
  { entry_point, query_id, query_length, query_submitted, query_type, session_id }: logAskAllTrailsQuerySubmittedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'ask all trails query submitted',
    {
      'entry point': entry_point,
      'query id': query_id,
      'query length': query_length,
      'query submitted': query_submitted,
      'query type': query_type,
      'session id': session_id
    },
    callback
  );
};

export default logAskAllTrailsQuerySubmitted;
